import React from 'react';
import {connect} from 'react-redux';
import {actionStarted} from '@ignitesales/neuro-application/src/actions/question-action-creators.mjs';
import ContactFlow from './ContactFlow.jsx';
import {
  appointmentLocationSelected,
  appointmentLocationSearchUpdated,
  getLocations, bookAppointment, getAvailableTimeSlots, appointmentTimeSlotSelected, contactLeadUpdate
} from '@ignitesales/neuro-application/src/actions/contactme-action-creators.mjs';

const ConnectedContactFlow = props => {
  const {
    hasBeenClicked,
    actionStarted,
    ...rest
  } = props;

  if(hasBeenClicked){
    actionStarted();
  }

  return  <ContactFlow {...rest} />;
};

export default connect((state) => {
  const contactMe = state.contactMe || {};
  const defaultZipCode = state.answers?.postalCode?.value?.toString();

  return {
    availableLocations: contactMe.availableLocations,
    availableTimeSlots: contactMe.availableTimeSlots,
    contactLead: contactMe.contactLead,
    isProcessing: contactMe.isProcessing,
    locationSearchForm: contactMe.locationSearchForm || { zipCode: defaultZipCode },
    selectedLocation: contactMe.selectedLocation,
    selectedTime : contactMe.selectedTime,
  };
}, dispatch => {
  return {
    actionStarted: () => {
      dispatch(actionStarted({actionName: 'makeAppointmentClicked'}));
    },
    onContactFormSubmit: (contactLead, fieldsForAnswerService) => {
      dispatch(contactLeadUpdate({contactLead, fieldsForAnswerService}));
    },
    onLocationSearchChange: (search) => {
      dispatch(appointmentLocationSearchUpdated(search));
    },
    setLocation: (location) => {
      dispatch(appointmentLocationSelected(location));
    },
    getLocations: (coordinates) => {
      dispatch(getLocations(coordinates));
    },
    getTimeSlots: (request) => {
      dispatch(getAvailableTimeSlots(request));
    },
    setTimeSlot: (timeSlot) => {
      dispatch(appointmentTimeSlotSelected(timeSlot));
    },
    bookAppointment: (appointment, getNextScreen) => {
      dispatch(bookAppointment(appointment, getNextScreen));
    }
  };
})(ConnectedContactFlow);
